import { createRootRoute, Outlet } from '@tanstack/react-router';
import { MockAuthProvider } from '../hooks/useMockAuth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DevTools } from '../components/DevTools';
import { RootLayout } from '../components/layouts/RootLayout';
import { ThemeProvider } from '../contexts/ThemeContext';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <MockAuthProvider>
          <RootLayout>
            <Outlet />
          </RootLayout>

          {/* Dev Tools - Only show in development */}
          {import.meta.env.DEV && (
            <>
              <DevTools />
              <ReactQueryDevtools buttonPosition="bottom-right" />
            </>
          )}
        </MockAuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
